import { Messages } from '../../codegen/Localize';
import { Module } from '../Module';

export interface IListFilter {
  (items: string[]): string;
}

function formatListMiddleAndEnd(items: string[]): string {
  if (items.length === 2) {
    return Messages.listEnd({
      START_ITEMS: items[0],
      LAST_ITEM: items[1]
    });
  }
  return Messages.listMiddle({
    FIRST_ITEMS: items[0],
    LAST_ITEMS: formatListMiddleAndEnd(items.slice(1))
  });
}

function listFilter(items: string[]) {
  switch(items.length) {
    case 0:
      return '';
    case 1:
      return items[0];
    case 2:
      return Messages.listTwo({
        ITEM1: items[0],
        ITEM2: items[1]
      });
    default:
      return Messages.listStart({
        FIRST_ITEM: items[0],
        REMAINING_ITEMS: formatListMiddleAndEnd(items.slice(1))
      });
  }
}

export const ListFilter: IListFilter = listFilter;

Module.instance().filter('list', () => ListFilter);
